import React from 'react';
import { Empty } from 'antd';

const NotFound: React.FC = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
      <Empty description="目前沒有內容" />
    </div>
  );
};

export default NotFound; 